import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'signed-petition-home',
		path: '/p/:slug/signed-petition-home',
		component: loadable(async () => import(/* webpackChunkName: "pages/signed_petition_home" */ './index'), {
			exportName: 'SignedPetitionHome',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
